import type RichTextEditorBase from 'rich-text-editor/build';

type Emoji = {
  character: string;
  title: string;
};

const emojis = (options: Emoji[]) => {
  return function (editor: RichTextEditorBase) {
    // TODO: Translate strings `SpecialCharacters` and `Emoticons`
    editor.plugins.get('SpecialCharacters').addItems('Emoticons', options);
  };
};

export default emojis;
